function ReadingProgress() {
	return <div className="reading-progress" aria-hidden="true" />
}

export { ReadingProgress }
